module.exports = __webpack_public_path__ + "img/shopping-cart.630af401.svg";